import React, { useState } from "react";

import { useHistory } from "react-router-dom";

import {
    ActionMenu,
    ActionMenuItem,
    AddIcon,
    BlockIcon,
    Button,
    IconButton,
    PageHeaderActions,
    TuneIcon,
} from "shared/ui";

import { useMenuEditorContext } from "features/MenuEditor/context";

import {
    CompactAction,
    CompactManage,
    CornerBadge,
    InlineBadge,
    Toolbar,
    WideAction,
    WideManage,
} from "./styles";

/*
* Действия над всем меню — в шапке страницы, рядом с заголовком (как в макете).
* Переносим порталом через PageHeaderActions: кнопкам нужно состояние экрана, а узел,
* отданный в шапку через стор, рендерился бы внутри Header и контекста фичи не видел.
* Широкий и свёрнутый варианты кнопки — два узла, переключаемые медиазапросом: так каждый
* остаётся обычным примитивом кита, без кнопки-трансформера с тремя режимами внутри.
* */
export const MenuEditorToolbar = () => {
    const state = useMenuEditorContext();
    const history = useHistory();

    const [addAnchorEl, setAddAnchorEl] = useState<HTMLElement | null>(null);

    const stopListCount = state.summary.stopListItemsCount;
    const openStopList = () => history.push(`/menus/regular/${state.menuId}/stoplist`);
    const openManagement = () => state.openDialog({ kind: "manage" });

    // Единственная точка добавления в интерфейсе: и позиция, и категория заводятся отсюда.
    const addActions: ActionMenuItem[] = [
        {
            key: "item",
            label: "Позиция",
            hint: "Блюдо или напиток в выбранную категорию",
            disabled: state.categories.length === 0,
            onClick: () => state.openDialog({ kind: "createItem" }),
        },
        {
            key: "category",
            label: "Категория",
            hint: "Раздел меню: завтраки, супы, напитки",
            onClick: () => state.openDialog({ kind: "createCategory" }),
        },
    ];

    return (
        <PageHeaderActions>
            <Toolbar>
                <WideAction>
                    <Button variant="outlined" color="neutral" onClick={openStopList}>
                        <BlockIcon />
                        Стоп-лист
                        {stopListCount > 0 && <InlineBadge>{stopListCount}</InlineBadge>}
                    </Button>
                </WideAction>

                <CompactAction>
                    <IconButton
                        label="Стоп-лист"
                        size="large"
                        variant="outlined"
                        onClick={openStopList}
                    >
                        <BlockIcon />
                    </IconButton>
                    {stopListCount > 0 && <CornerBadge>{stopListCount}</CornerBadge>}
                </CompactAction>

                <WideManage>
                    <Button variant="outlined" color="neutral" onClick={openManagement}>
                        <TuneIcon />
                        Управление меню
                    </Button>
                </WideManage>

                <CompactManage>
                    <IconButton
                        label="Управление меню"
                        size="large"
                        variant="outlined"
                        onClick={openManagement}
                    >
                        <TuneIcon />
                    </IconButton>
                </CompactManage>

                <WideManage>
                    <Button
                        variant="contained"
                        onClick={(event) => setAddAnchorEl(event.currentTarget)}
                    >
                        <AddIcon />
                        Добавить
                    </Button>
                </WideManage>

                <CompactManage>
                    <IconButton
                        label="Добавить"
                        size="large"
                        variant="outlined"
                        onClick={(event) => setAddAnchorEl(event.currentTarget)}
                    >
                        <AddIcon />
                    </IconButton>
                </CompactManage>

                <ActionMenu
                    open={!!addAnchorEl}
                    anchorEl={addAnchorEl}
                    title="Добавить"
                    items={addActions}
                    onClose={() => setAddAnchorEl(null)}
                />
            </Toolbar>
        </PageHeaderActions>
    );
};
